<script setup lang="ts">
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'
import BaseLayerVector from '@/components/map/base-layers/BaseLayerVector.vue'
import { useMapStore } from '~/stores/map'

const mapStore = useMapStore()
const activeMunicipalityId = computed(() => mapStore.activeMunicipalityId)
const { features } = useGeojsonDataFetch('municipalities')

// vi skjuter in stylen för aktiv rakt in
watch(features, () => {
  setFeatures()
})

if (features.value.length) {
  setFeatures()
}
function setFeatures() {
  if (!features.value.length) return
  features.value.forEach((feature) => {
    feature.set('label', feature.get('municipality_name'))
    feature.set('link', '/utforska-en-plats/kommun/' + feature.get('slug'))
    feature.set('type', 'region')
    if (feature.get('municipality_code') === activeMunicipalityId.value) {
      const strokeWidth = 2
      const color = 'black'
      const vectorStyle = new Style({
        // fill: new Fill({
        //   color: colorScale(index).alpha(0.2).hex(),
        // }),
        stroke: new Stroke({
          width: strokeWidth,
          color,
        }),
        zIndex: 90,
      })
      feature.setStyle(vectorStyle)
    }
  })
}
</script>

<template>
  <BaseLayerVector v-if="features.length" :features="features" />
</template>
